import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import css from './CompaniesPage.module.css';
import talent1 from '../../assets/best-talent-img1.png';
import talent2 from '../../assets/best-talent-img2.png';
import talent3 from '../../assets/best-talent-img3.png';
import talent4 from '../../assets/best-talent-img4.png';
import talent5 from '../../assets/best-talent-img5.png';
import talent6 from '../../assets/best-talent-img6.png';
import { isLocaleGreek, onSendEmail } from '../../util/genericHelpers';
import { NamedLink } from '../../components';

function SectionBestTalent() {
  return (
    <div className={css.bestTalentContainer}>
      <div className={css.contentWidth}>
        <div className={css.talentContent}>
          <h2>
            <FormattedMessage id="CompaniesPage.talentHeading" />
          </h2>
          <div className={css.talentSection}>
            <div className={css.talentBlock}>
              <div className={css.talentImg}>
                <img src={talent1} alt="talent" />
              </div>
              <h2>
                <FormattedMessage id="CompaniesPage.talentSubHeading1" />{' '}
              </h2>
              <p>
                <FormattedMessage id="CompaniesPage.talentDescription1" />
              </p>
            </div>
            <div className={css.talentBlock}>
              <div className={css.talentImg}>
                <img src={talent2} alt="talent" />
              </div>
              <h2>
                <FormattedMessage id="CompaniesPage.talentSubHeading2" />{' '}
              </h2>
              <p>
                <FormattedMessage id="CompaniesPage.talentDescription2" />
              </p>
            </div>
            <div className={css.talentBlock}>
              <div className={css.talentImg}>
                <img src={talent3} alt="talent" />
              </div>
              <h2>
                <FormattedMessage id="CompaniesPage.talentSubHeading3" />{' '}
              </h2>
              <p>
                <FormattedMessage id="CompaniesPage.talentDescription3" />
              </p>
            </div>
            <div className={css.talentBlock}>
              <div className={css.talentImg}>
                <img src={talent4} alt="talent" />
              </div>
              <h2>
                <FormattedMessage id="CompaniesPage.talentSubHeading4" />{' '}
              </h2>
              <p>
                <FormattedMessage id="CompaniesPage.talentDescription4" />
              </p>
            </div>
            <div className={css.talentBlock}>
              <div className={css.talentImg}>
                <img src={talent5} alt="talent" />
              </div>
              <h2>
                <FormattedMessage id="CompaniesPage.talentSubHeading5" />{' '}
              </h2>
              <p>
                <FormattedMessage id="CompaniesPage.talentDescription5" />
              </p>
            </div>
            <div className={css.talentBlock}>
              <div className={css.talentImg}>
                <img src={talent6} alt="talent" />
              </div>
              <h2>
                <FormattedMessage id="CompaniesPage.talentSubHeading6" />{' '}
              </h2>
              <p>
                <FormattedMessage id="CompaniesPage.talentDescription6" />
              </p>
            </div>
          </div>
        </div>
        <div className={css.registerNowBtn}>
          <NamedLink name="ContactPage" className={css.registerBtn}>
            <FormattedMessage id="CompaniesPage.registerButton" />
          </NamedLink>
        </div>
      </div>
    </div>
  );
}

export default SectionBestTalent;
